import {
  modifyDefaultFabricControls,
} from '@/components/Editor/helpers/fabric/controls/modifyDefaultFabricControls';
import { addGuidelinesToObject } from '@/components/Editor/helpers/Guidelines';
import { FabricText } from '@/components/Editor/types/fabric';

export const setCustomPropsToText = (
  fabricText: FabricText,
): void => {
  modifyDefaultFabricControls(fabricText);
  addGuidelinesToObject(fabricText);
};
